import { patch, post } from "@insite/client-framework/Services/ApiService";
import {
    BaseModel,
    GetQuotesListApiParameter,
    OrderCollectionModel,
    PaginationModel,
} from "@insite/client-framework/Types/ApiModels";

export interface QuotesListModel extends BaseModel {
    quotesList: OrderCollectionModel;
}

export interface QuoteSearchFilter {
    orderNumber?: string | null;
    PoNumber?: string | null;
    search?: string | null;
    status: string[];
    customerSequence?: string | null;
    FromDate?: string | null;
    ToDate?: string | null;
    orderTotalOperator?: string | null;
    OrderTotal?: number | null;
    productErpNumber?: number | null;
    currentPage?: number | null;
    Page?: number | null;
    PageSize?: number | null;
    sort?: string | null;
    ordersearchtype?: string | null;
    quoteType?: number | null;
}

export interface AdiGlobalQuoteSearchFilter {
    refrencenumber?: string;
    orderType?: string;
    selectedpage?: number;
    customerSequence?: string;
    sort?: string;
    dateType?: string;
    toDate?: string;
    fromDate?: string;
    poNumber?: string;
    ordernumber?: string;
    ordertotaloperator?: string;
    ordertotal?: string;
    status: string;
    statusDesc?: string;
    quotenumber?: string;
    ordersearchtype: string;
    isSearch?: boolean;
    dateRange?: string;
    dateRangeDesc?: string;
    isSearchResult?: boolean;
    quotetype?: string;
    quotetypeDesc?: string;
    isrecentquote?: boolean;
    isChangeCustomer?: boolean;
    pageSize?: number;
    page?: number;
    currentPage?: number;
}

export async function getQuotesList(parameter: GetQuotesListApiParameter) {
    var quotesListUrl = "/api/v2/orders/quoteList";
    
    if (!parameter.filter) {
        return;
    }

    if (parameter.filter.ordersearchtype != null || parameter.filter.status != null) {
        quotesListUrl += "?";
        quotesListUrl += "properties={";
    }
    if (parameter.filter.ordersearchtype != null && parameter.filter.ordersearchtype !== "") {
        quotesListUrl += "'ordersearchtype':'ALL',";
    }
    if (parameter.filter.status != null && parameter.filter.status !== "") {
        quotesListUrl += "'status':'" + parameter.filter.status + "',";
    }

    if (parameter.filter.quotetype != null && parameter.filter.quotetype !== "") {
        var qtype = parameter.filter.quotetype;
        if (parameter.filter.ordersearchtype === "Project Quote") {
            qtype = "1";
        }
        if (parameter.filter.ordersearchtype === "Regular Quote") {
            qtype = "2";
        }
        quotesListUrl += "'quotetype':'" + qtype + "',";
    }

    if (quotesListUrl.indexOf("properties") !== -1) {
        quotesListUrl += "}";
    }

    let filterParameter: QuoteSearchFilter = {
        orderNumber: null,
        PoNumber: null,
        search: null,
        status: [],
        customerSequence: parameter.filter.customerSequence,
        FromDate: parameter.filter.fromDate,
        ToDate: parameter.filter.toDate,
        orderTotalOperator: null,
        OrderTotal: 0,
        productErpNumber: null,
        currentPage: null,
        Page: null,
        PageSize: null,
        sort: parameter.filter.sort,
        ordersearchtype: parameter.filter.ordersearchtype,
        quoteType: parameter.filter.ordersearchtype === 'Project Quote' ? 1 : parameter.filter.ordersearchtype === 'Regular Quote' ? 2 : -1,
    };

    filterParameter.status.push("QU");

    if (parameter.filter.poNumber !== "") {
        filterParameter.PoNumber = parameter.filter.poNumber;
    }
    if (parameter.filter && parameter.filter.pageSize) {
        filterParameter.PageSize = parameter.filter.pageSize;
    }
    if (parameter.filter && parameter.filter.currentPage) {
        filterParameter.currentPage = parameter.filter.currentPage;
    }
    if (parameter.filter && parameter.filter.page) {
        filterParameter.Page = parameter.filter.page;
    }
    const result = await patch<OrderCollectionModel>(quotesListUrl, filterParameter as any);
    return result;
}

export async function getProductInformation(parameter: String[]) {
    let url = "/api/v3/adiglobalproducts/batchgetCustom";
    const res = await post<any>(`${url}`, {
        extendedNames: parameter,
    });
    return res;
}
